export default __webpack_public_path__ + "static/media/KOD0136-min.12825847.webp";